import $ from "jquery";

import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

const ImageSlider = (el) => {
    let $el = $(el);

    if ($el.length === 0) {
        throw new Error("Element not found for Swiper initialization [ImageSlider]");
    }
    let imageSlider = new Splide(el, {
        autoScroll: {
            speed: 1,
        },
        type: "loop",
        gap: "2.4rem",
        perPage: 1,
        autoWidth: true,
    }).mount({ AutoScroll });
};

export default ImageSlider;
